module.exports = __webpack_public_path__ + "static/media/korber.4bed58d8.png";